import StorageUtil from '../../util/storage_util';
import ModalUtil from '../../util/modal_util';
import { isSoloare } from '../js_env';
import { Env } from '../../env';

/// ローカルストレージカゴお気に入りモーダル非表示キー論理名
const HIDE_CART_FAVORITE_MODAL_KEY = 'HIDE_CART_FAVORITE_MODAL';
/// ローカルストレージカゴお気に入りモーダル非表示の設定値
const HIDE_CART_FAVORITE_MODAL_VALUE = '1';
/// カゴに入れましたモーダルID
const ADD_CART_MODAL_ID = 'modal-SLPSRC015';
// カゴに入れましたモーダルの合計数ID
const ADD_CART_MODAL_TOTAL_COUNT_ID = 'addModalTotalCount';
// カゴに入れましたモーダルの合計金額ID
const ADD_CART_MODAL_TOTAL_AMOUNT_ID = 'addModalTotalAmount';
// カゴに入れましたモーダルの同一商品時のメッセージID
const ADD_CART_MODAL_SAME_ITEM_MESSAGE_ID = 'addModalSameItemMessage';

// カゴに入れましたツールチップのID
const ADD_CART_TOOL_TIP_ID = 'addcart-01';
// カゴに入れましたツールチップの合計数ID
const ADD_CART_TOOL_TIP_TOTAL_COUNT_ID = 'addTooltipTotalCount';
// カゴに入れましたツールチップの合計金額ID
const ADD_CART_TOOL_TIP_TOTAL_AMOUNT_ID = 'addTooltipTotalAmount';
// カゴに入れましたツールチップの同一商品時のメッセージID
const ADD_CART_TOOL_TIP_SAME_ITEM_MESSAGE_ID = 'addTooltipSameItemMessage';
// カゴに入れましたツールチップのカゴを見るボタンID
const ADD_CART_TOOL_TIP_CART_WATCH_ID = 'addTooltipCartWatchButton';
// カゴに入れましたツールチップのレジへボタンID
const ADD_CART_TOOL_TIP_ORDER_VIEW_ID = 'addTooltipOrderView';
// カゴに入れましたツールチップの商品画像ID
const ADD_CART_TOOL_TIP_ITEM_IMAGE_ID = 'addTooltipItemImage';

// お買い物かご画面URL(CLUB)
const CART_VIEW_CLUB_URL = '/odr/order/shoppingCartView/';
// お買い物かご画面URL(SOLOARE)
const CART_VIEW_SOLOARE_URL = '/buyer/view/a130/DAE01010.html?fromHeaderFlg=true';
// レジ画面URL(CLUB)
const ORDER_CLUB_URL = '/odr/order/orderProcess/direct';

// R1 CLUBヘッダーカゴボタン内の数量クラス名
const R1_CLUB_HEADER_ITEM_COUNT_IN_CART_BUTTON_CLASS = 'num_basket';

// R1 ソロアリヘッダーカゴ内商品数量ID
const R1_SOLOARE_HEADER_ITEM_COUNT_ID = 'cartItemCount';

// R1 ソロアリヘッダーカゴ内商品数量ID（トップから離れると出てくるバー内の数量）
const R1_SOLOARE_HEADER_ITEM_COUNT_ID_IN_BAR = 'cartBarItemCount';

// R1 ソロアリヘッダーカゴ内商品合計金額ID
const R1_SOLOARE_HEADER_TOTAL_AMOUNT_ID = 'cartIntaxOdrSubttlAmnt-2';

// R1 ソロアリヘッダーカゴ内商品合計金額ID（ヘッダーのバルーン内）
const R1_SOLOARE_HEADER_TOTAL_AMOUNT_ID_IN_BALLOON = 'cartIntaxOdrSubttlAmnt';

// R1 ソロアリヘッダーカゴ内商品合計金額ID（トップから離れると出てくるバーのバルーン内）
const R1_SOLOARE_HEADER_TOTAL_AMOUNT_ID_IN_BAR_BALLOON = 'cartBarIntaxOdrSubttlAmnt';

// ツールチップの画像がない場合、デフォルの画像 (lサイズ使うのは、キャッシュ再利用しやすいため)
const DEFAULT_TOOLTIP_IMAGE = '//askul.c.yimg.jp/img/product/L1/noimage_l1.jpg';

const addCart = window._addcart;

// カゴに入れましたモーダルを表示
const SHOW_ADD_CART_MODAL = 'true'

export class AddCartViewModal {

  /// モーダル表示
  static async view(
    targetElement: HTMLElement,
    isSameItem: boolean,
    totalAmount: number,
    totalCount: number,
    itemImageUrl: string,
    id: string,
    viewName: string
  ) {

    /// ローカルストレージ.カゴお気に入りモーダル非表示の値を取得する
    const hideCartFavoriteModalValue = StorageUtil.getItemWithExpiration(
      HIDE_CART_FAVORITE_MODAL_KEY
    );

    const shouldShowModal = targetElement.dataset.shouldShowModal === SHOW_ADD_CART_MODAL

    if (hideCartFavoriteModalValue !== HIDE_CART_FAVORITE_MODAL_VALUE && shouldShowModal) {
      AddCartViewModal.viewModal(
              isSameItem,
              totalAmount,
              totalCount,
              id,
              viewName);
    } else {
      AddCartViewModal.viewTooltip(
              targetElement,
              isSameItem,
              totalAmount,
              totalCount,
              itemImageUrl,
              id,
              viewName);
    }

    // (R1のみ)CLUBヘッダーカゴボタン内の数量を更新する
    const r1ClubHeaderItemCountElement = document.getElementsByClassName(R1_CLUB_HEADER_ITEM_COUNT_IN_CART_BUTTON_CLASS);
    if (typeof r1ClubHeaderItemCountElement !== 'undefined' &&
      r1ClubHeaderItemCountElement !== null &&
      r1ClubHeaderItemCountElement.length === 1
    ) {
      r1ClubHeaderItemCountElement[0].innerHTML = `${totalCount}` as string;
    }
    // (R1のみ)ソロアリヘッダーカゴ内商品数量を更新する
    const r1SoloareHeaderItemCountElement = document.getElementById(R1_SOLOARE_HEADER_ITEM_COUNT_ID);
    if (typeof r1SoloareHeaderItemCountElement !== 'undefined' &&
      r1SoloareHeaderItemCountElement !== null
    ) {
      r1SoloareHeaderItemCountElement.innerHTML = `${totalCount}` as string;
    }
    // (R1のみ)ソロアリヘッダーカゴ内商品数量を更新する（トップから離れると出てくるバー内の数量）
    const r1SoloareHeaderItemCountInBarElement = document.getElementById(R1_SOLOARE_HEADER_ITEM_COUNT_ID_IN_BAR);
    if (typeof r1SoloareHeaderItemCountInBarElement !== 'undefined' &&
      r1SoloareHeaderItemCountInBarElement !== null
    ) {
      r1SoloareHeaderItemCountInBarElement.innerHTML = `${totalCount}` as string;
    }
    // (R1のみ)ソロアリヘッダーカゴ内合計金額を更新する
    const r1SoloareHeaderTotalAmountElement = document.getElementById(R1_SOLOARE_HEADER_TOTAL_AMOUNT_ID);
    if (typeof r1SoloareHeaderTotalAmountElement !== 'undefined' &&
      r1SoloareHeaderTotalAmountElement !== null
    ) {
      r1SoloareHeaderTotalAmountElement.innerHTML = `${totalAmount.toLocaleString()}`;
    }
    // (R1のみ)ソロアリヘッダーカゴ内合計金額を更新する（バルーン）
    const r1SoloareHeaderTotalAmountInBalloonElement = document.getElementById(R1_SOLOARE_HEADER_TOTAL_AMOUNT_ID_IN_BALLOON);
    if (typeof r1SoloareHeaderTotalAmountInBalloonElement !== 'undefined' &&
      r1SoloareHeaderTotalAmountInBalloonElement !== null
    ) {
      r1SoloareHeaderTotalAmountInBalloonElement.innerHTML = `${totalAmount.toLocaleString()}`;
    }
    // (R1のみ)ソロアリヘッダーカゴ内商品合計金額ID（トップから離れると出てくるバーのバルーン内）
    const r1SoloareHeaderTotalAmountInBarBalloonElement = document.getElementById(R1_SOLOARE_HEADER_TOTAL_AMOUNT_ID_IN_BAR_BALLOON);
    if (typeof r1SoloareHeaderTotalAmountInBarBalloonElement !== 'undefined' &&
      r1SoloareHeaderTotalAmountInBarBalloonElement !== null
    ) {
      r1SoloareHeaderTotalAmountInBarBalloonElement.innerHTML = `${totalAmount.toLocaleString()}`;
    }
  }

  private static viewTooltip(
    targetElement: HTMLElement,
    isSameItem: boolean,
    totalAmount: number,
    totalCount: number,
    itemImageUrl: string,
    id: string,
    viewName: string
  ) {
    let addCartToolTipId = ADD_CART_TOOL_TIP_ID;
    let addCartToolTipTotalCountId = ADD_CART_TOOL_TIP_TOTAL_COUNT_ID;
    let addCartToolTipTotalAmountId = ADD_CART_TOOL_TIP_TOTAL_AMOUNT_ID;
    let addCartToolTipSameItemMessageId = ADD_CART_TOOL_TIP_SAME_ITEM_MESSAGE_ID;
    let addCartToolTipCartWatchId = ADD_CART_TOOL_TIP_CART_WATCH_ID;
    let addCartToolTipOrderViewId = ADD_CART_TOOL_TIP_ORDER_VIEW_ID;
    let addCartToolTipItemImageId = ADD_CART_TOOL_TIP_ITEM_IMAGE_ID;

    if (AddCartViewModal.isRecentCheck(viewName) || AddCartViewModal.hasAddCartResultDisplayId(id)) {
      /// IDを末尾に付与している
      addCartToolTipId = ADD_CART_TOOL_TIP_ID + '-' + id;
      addCartToolTipTotalCountId = ADD_CART_TOOL_TIP_TOTAL_COUNT_ID + '-' + id;
      addCartToolTipTotalAmountId = ADD_CART_TOOL_TIP_TOTAL_AMOUNT_ID + '-' + id;
      addCartToolTipSameItemMessageId = ADD_CART_TOOL_TIP_SAME_ITEM_MESSAGE_ID + '-' + id;
      addCartToolTipCartWatchId = ADD_CART_TOOL_TIP_CART_WATCH_ID + '-' + id;
      addCartToolTipOrderViewId = ADD_CART_TOOL_TIP_ORDER_VIEW_ID + '-' + id;
      addCartToolTipItemImageId = ADD_CART_TOOL_TIP_ITEM_IMAGE_ID + '-' + id;
    }
    /// ローカルストレージ.カゴお気に入りモーダル非表示が1の場合、カゴにいれました吹き出しを表示する
    // 同一商品時のメッセージ表示
    const sameItemMessageModalElement = document.getElementById(addCartToolTipSameItemMessageId);
    if (sameItemMessageModalElement) {
      sameItemMessageModalElement.style.display = isSameItem ? 'block' : 'none';
    }
    // 商品画像表示
    const sameItemMessageElement = document.getElementById(addCartToolTipItemImageId) as HTMLImageElement | null;
    if (sameItemMessageElement) {
      sameItemMessageElement.dataset.src = itemImageUrl || DEFAULT_TOOLTIP_IMAGE;
      sameItemMessageElement.src = itemImageUrl || DEFAULT_TOOLTIP_IMAGE;
    }
    // 合計数を設定する
    const totalCountElement = document.getElementById(addCartToolTipTotalCountId);
    if (totalCountElement) {
      totalCountElement.innerHTML = `${totalCount}` as string;
    }
    // 合計金額を設定する
    const totalAmountElement = document.getElementById(addCartToolTipTotalAmountId);
    if (totalAmountElement) {
      totalAmountElement.innerHTML = '￥' + `${totalAmount.toLocaleString()}`;
    }
    // カゴを見るの遷移先を設定する
    const watchCartElement = document.getElementById(addCartToolTipCartWatchId);
    if (watchCartElement) {
      if (isSoloare(Env.SITE_TYPE)) {
        watchCartElement.setAttribute('href', CART_VIEW_SOLOARE_URL);
      } else {
        watchCartElement.setAttribute('href', CART_VIEW_CLUB_URL);
      }
    }
    // レジへボタンの遷移先を設定する
    const goOrderElement = document.getElementById(addCartToolTipOrderViewId);
    if (goOrderElement) {
      if (isSoloare(Env.SITE_TYPE)) {
        goOrderElement.style.display = 'none';
      } else {
        goOrderElement.setAttribute('href', ORDER_CLUB_URL);
      }
    }

    // ツールチップ表示
    const addCartCls = new addCart();
    const tooltipElement = document.getElementById(addCartToolTipId);
    if (tooltipElement) {
      addCartCls.onShowTooltip(tooltipElement, targetElement);
    }
  }

  private static isRecentCheck(viewName: string) {
    return viewName === "recent_checked";
  }

  private static hasAddCartResultDisplayId(addCartResultDisplayId: string) {
    return addCartResultDisplayId !== '';
  }

  private static viewModal(
    isSameItem: boolean,
    totalAmount: number,
    totalCount: number,
    id: string,
    viewName: string
  ) {

    let addCartModalId = ADD_CART_MODAL_ID;
    let addCartModalTotalCountId = ADD_CART_MODAL_TOTAL_COUNT_ID;
    let addCartModalTotalAmountId = ADD_CART_MODAL_TOTAL_AMOUNT_ID;
    let addCartModalSameItemMessageId = ADD_CART_MODAL_SAME_ITEM_MESSAGE_ID;

    if (AddCartViewModal.isRecentCheck(viewName)) {
      /// IDを末尾に付与している
      addCartModalId = ADD_CART_MODAL_ID + '-' + id;
      addCartModalTotalCountId = ADD_CART_MODAL_TOTAL_COUNT_ID + '-' + id;
      addCartModalTotalAmountId = ADD_CART_MODAL_TOTAL_AMOUNT_ID + '-' + id;
      addCartModalSameItemMessageId = ADD_CART_MODAL_SAME_ITEM_MESSAGE_ID + '-' + id;
    }

    /// ローカルストレージ.カゴお気に入りモーダル非表示が未設定、または1以外の場合、カゴにいれましたモーダル画面を表示する
    // 同一商品時のメッセージ表示
    const sameItemMessageElement = document.getElementById(addCartModalSameItemMessageId);
    if (sameItemMessageElement) {
      sameItemMessageElement.style.display = isSameItem ? 'block' : 'none';
    }
    // 合計数を設定する
    const totalCountElement = document.getElementById(addCartModalTotalCountId);
    if (totalCountElement) {
      totalCountElement.innerHTML = `${totalCount}` as string;
    }
    // 合計金額を設定する
    const totalAmountElement = document.getElementById(addCartModalTotalAmountId);
    if (totalAmountElement) {
      totalAmountElement.innerHTML = '￥' + `${totalAmount.toLocaleString()}`;
    }
    ModalUtil.show(addCartModalId);
  }

}
